import { UnstyledButton } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "../../../platform/media/slots.module.css";
import { Soon } from "../../../ui/Soon";

/** A slot the composer keeps in live's place, Coming soon: its icon and label, no action. */
export function SoonSlot({ label, icon }: { label: string; icon: ReactNode }) {
  return (
    <Soon>
      {(soonProps) => (
        <UnstyledButton {...soonProps} className={classes.slot} aria-label={label}>
          {icon}
          <span className={classes.slotLabel}>{label}</span>
        </UnstyledButton>
      )}
    </Soon>
  );
}
